import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import Layout from '@/components/layout/Layout';
import SEOHead from '@/components/SEOHead';
import HeroSection from '@/components/home/HeroSection';
import WhyChooseSection from '@/components/home/WhyChooseSection';
import ConexusFormulaSection from '@/components/home/ConexusFormulaSection';
import YouTubeSection from '@/components/home/YouTubeSection';
import FeaturedProgramsSection from '@/components/home/FeaturedProgramsSection';

import TestimonialsSection from '@/components/home/TestimonialsSection';
import LeadCaptureSection from '@/components/home/LeadCaptureSection';
import CTASection from '@/components/home/CTASection';

const Home = () => {
  const { t } = useTranslation();

  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://www-cdn.icef.com/scripts/iasbadgeid.js';
    script.async = true;
    script.defer = true;
    script.crossOrigin = 'anonymous';
    document.body.appendChild(script);
    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return (
    <Layout>
      <SEOHead
        title={t('seo.home.title')}
        description={t('seo.home.description')}
        keywords={t('seo.home.keywords')}
        path="/"
      />
      <HeroSection />
      <WhyChooseSection />
      <ConexusFormulaSection />
      <YouTubeSection />
      <FeaturedProgramsSection />
      <TestimonialsSection />
      <LeadCaptureSection />
      <CTASection />
    </Layout>
  );
};

export default Home;
